export default "__VITE_ASSET__oqjQrk6f__"